<template lang="pug">
div
  el-row.pad5
    el-col.labelLogradouro(:span="12")
      p
        span.label Logradouro:
        span.breakText &nbsp {{filterNull(endereco.logradouro)}}
    el-col(:span="12")
      p
        span.label Número:
        span.breakText &nbsp {{filterNumber(endereco.numero)}}
    el-col(:span="12")
      p
        span.label Complemento:
        span.breakText &nbsp {{filterNull(endereco.complemento)}}
    el-col(:span="12")
      p
        span.label Bairro:
        span.breakText &nbsp {{filterNull(endereco.bairro)}}
    el-col(:span="12")
      p
        span.label CEP:
        span.breakText &nbsp {{filterNull(endereco.cep)}}
    el-col(:span="12")
      p
        span.label UF:
        span.breakText &nbsp {{getEstado(endereco.municipio.estado)}}
    el-col(:span="12")
      p
        span.label Município:
        span.breakText &nbsp {{filterNull(endereco.municipio.nome)}}
</template>
<script>
const estados = require('@/utils/estados').default

export default {
  props: {
    endereco: {
      type: Object,
      required: true
    }
  },
  methods: {
    filterNull (atributo) {
      return (atributo !== null && atributo !== '') ? atributo : '-'
    },
    filterNumber (numero) {
      return numero || 'S/N'
    },
    getEstado (uf) {
      const estadoAtual = estados.filter(estado => estado.codigo === uf)
      return `${uf} (${estadoAtual[0].nome})`
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }
  .labelLogradouro {
    width: 260px
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoEndereco.vue